import styled from 'styled-components';

export const NestedNumberedListContainer = styled.div`
  font-size: 14px;
  line-height: 2;

  ol {
    counter-reset: item;
  }

  ol > li {
    counter-increment: item;
  }

  ol ol > li {
    position: relative;
    display: block;
  }

  ol ol li:before {
    position: absolute;
    top: 0;
    content: counters(item, '.') '. ';
  }

  ol ol > li:before {
    left: -30px;
  }

  ol ol ol > li:before {
    left: -40px;
  }
`;
